// @flow
import styled from '@emotion/styled'
import { useFormik } from 'formik'
import * as React from 'react'

import { colors } from '@toggl/style'

import { IconSearch } from '../icons/IconSearch'
import * as text from '../text'

type Props = {|
  +className?: string,
  +initialValue?: string | null,
  +placeholder: string,
  +onSearch: (string) => void,
|}

export const Search = ({
  className,
  initialValue,
  placeholder,
  onSearch,
}: Props) => {
  const formik = useFormik({
    initialValues: {
      search: initialValue || '',
    },
    onSubmit: ({ search }) => {
      onSearch(search)
    },
    enableReinitialize: true,
  })

  return (
    <form
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          formik.handleSubmit()
        }
      }}
      onSubmit={formik.handleSubmit}
    >
      <Wrapper className={className}>
        <SubmitButton type="submit" hasValue={!!formik.values.search}>
          <IconSearch />
        </SubmitButton>
        <Input
          id="search"
          name="search"
          placeholder={placeholder}
          onChange={formik.handleChange}
          value={formik.values.search}
        />
      </Wrapper>
    </form>
  )
}

const SubmitButton: React.ComponentType<any> = styled.button`
  border: none;
  outline: none;
  margin: 0;
  padding: 0;
  cursor: pointer;
  background: transparent;
  svg {
    width: 18px;
    path {
      fill: ${colors.darkPurple70};
    }
  }
`

const Wrapper: React.ComponentType<any> = styled.div`
  display: flex;
  padding: 5px 0;
  width: 100%;
  border-bottom: 1px solid ${colors.darkPurple70};
`

const Input: React.ComponentType<any> = styled.input`
  max-width: 250px;
  outline: none;
  border: none;
  flex-grow: 1;

  ${text.paragraph3};
  color: ${colors.darkPurple70};

  ::placeholder {
    color: ${colors.darkPurple70};
  }

  padding: 0 10px;
  background: transparent;
`
